var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowEnvBar())?_c('div',{staticClass:"ambient-bar",class:{ 'ambient-bar-DEV': _vm.isDev }},[_c('span',[_vm._v(_vm._s(_vm.ambientName))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }